import { render, staticRenderFns } from "./ResCommon.vue?vue&type=template&id=42364654&scoped=true"
import script from "./ResCommon.vue?vue&type=script&lang=js"
export * from "./ResCommon.vue?vue&type=script&lang=js"
import style0 from "./ResCommon.vue?vue&type=style&index=0&id=42364654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42364654",
  null
  
)

export default component.exports